export const fixImageUrl = (imgUrl) => {
  if (imgUrl) {
    const getIndex = imgUrl && imgUrl.indexOf("?");
    return imgUrl.slice(0, getIndex);
  }
};
   